import React from "react";
import Divider from "./divider";

const Card = ({ text }) => {
  return (
    <div
      style={{ boxShadow: "0 0 1rem rgba(0,0,0,0.1)" }}
      className="m-3 transform hover:-translate-y-1.5 text-gray-800 duration-300 p-5 bg-white rounded-xl"
    >
      <span className="text-red-500 font-bold text-2xl">{text[0]}</span>
      <span className="font-semibold">{text.substr(1)}</span>
    </div>
  );
};

export default function () {
  return (
    <section id="about" className="relative">
      <div
        className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
        style={{ height: "80px", transform: "translateZ(0px)" }}
      >
        <svg
          className="absolute bottom-0 overflow-hidden"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
        >
          <polygon
            className="text-white fill-current"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
      <Divider />
      <div className="text-center container mx-auto px-8">
        <div className="flex justify-center flex-col sm:flex-row items-center sm:items-end mb-4">
          <span className="mr-2 text-3xl font-semibold">Welcome to</span>
          <h2 className="font-bold text-3xl sm:text-4xl">
            <span className="text-red-500">Redd</span>
            <span>Wings</span>
            <span className="text-red-500">!</span>
          </h2>
        </div>
        <div className="mx-auto max-w-3xl text-gray-600 text-lg">
          <p>The Vision on ReddWings is to empower the youth of India</p>
          <p className="mt-2">
            ReddWings is India's best and most reliable Training and Placement
            Institute. It has existence not only in India, but also in Durba
            (South Africa). ReddWings's aim is to enable the youth of India to
            become employable by providing the necessery skills to them. It has
            been developing in its way and become a reowned Aviation and
            Hospitality training and placement institute.
          </p>
        </div>
      </div>
      <Divider />
      <div className="container mx-auto px-4">
        <div className="items-center flex flex-wrap">
          <div className="w-full md:w-4/12 ml-auto mr-auto px-4">
            <img
              alt="..."
              className="max-w-full rounded-lg shadow-lg"
              src="https://images.unsplash.com/photo-1555212697-194d092e3b8f?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=634&amp;q=80"
            />
          </div>
          <div className="w-full md:w-5/12 ml-auto mr-auto px-4">
            <div className="md:pr-12 md:mt-0 mt-8">
              <div className="text-pink-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-pink-300">
                <i className="fas fa-rocket text-xl"></i>
              </div>
              <h3 className="text-3xl font-semibold">The main motivation</h3>
              <p className="mt-4 text-lg leading-relaxed text-gray-600">
                It is to enable the youth of India to become employable,
                ensuring sustainable livelyhood and thereby reducing the
                hardship in our country. There is a huge gap between the
                unemployed and career opportunities in various sectors. Our aim
                is to fill up the gap and to provide rospects to the youth to
                excel in their career.
              </p>
              <ul className="list-none mt-6">
                <li className="py-2">
                  <div className="flex items-center">
                    <div>
                      <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200 mr-3">
                        <i className="fas fa-fingerprint"></i>
                      </span>
                    </div>
                    <div>
                      <h4 className="text-gray-600">
                        Cutting-endge skills and technology
                      </h4>
                    </div>
                  </div>
                </li>
                <li className="py-2">
                  <div className="flex items-center">
                    <div>
                      <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200 mr-3">
                        <i className="far fa-paper-plane"></i>
                      </span>
                    </div>
                    <div>
                      <h4 className="text-gray-600">Wide range of courses</h4>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Divider />
      <div className="container mx-auto px-4">
        <h2 className="text-6xl text-center font-bold">
          <span style={{ textShadow: "4px 4px 0 rgba(0,0,0,0.2)" }}>Why </span>
          <span
            style={{ textShadow: "4px 4px 0 rgba(239,68,68,0.2)" }}
            className="text-red-500"
          >
            Choose Us
          </span>
          <span style={{ textShadow: "4px 4px 0 rgba(0,0,0,0.2)" }}>?</span>
        </h2>
      </div>
      <div className="container mx-auto px-4 mt-12">
        <div
          style={{ maxWidth: "45rem" }}
          className="flex flex-wrap justify-center mx-auto"
        >
          <Card text="Technical Ride" />
          <Card text="Industrial Visits" />
          <Card text="Library" />
          <Card text="Recreational Trip" />
          <Card text="Dispatcher Lab" />
          <Card text="Air Conditioned Class" />
          <Card text="Mobile App (Student)" />
          <Card text="Placement Assistance" />
          <Card text="Practical Class" />
        </div>
      </div>
      <Divider />
    </section>
  );
}
